var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common" },
    [
      _c(
        "a-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.tabCur,
            callback: function($$v) {
              _vm.tabCur = $$v
            },
            expression: "tabCur"
          }
        },
        _vm._l(_vm.tabData, function(item) {
          return _c(
            "a-tab-pane",
            { key: item.key, attrs: { tab: item.name } },
            [
              _vm.tabCur == item.key
                ? _c(
                    "keep-alive",
                    [
                      _c(item.comp, {
                        tag: "component",
                        attrs: {
                          tabType: item.key,
                          gldStCds: item.gldStCds,
                          goldStatusOptions: item.goldStatusOptions,
                          rcPty: item.rcPty,
                          pypts: item.pypts,
                          isGldPay: item.isGldPay,
                          isGldLend: item.isGldLend,
                          pypt: item.pypt,
                          isGldEx: item.isGldEx,
                          exDayEnd: item.exDayEnd,
                          exDayStart: item.exDayStart,
                          formType: "seller",
                          totalName: item.totalName,
                          totalProp: item.totalProp,
                          columnsSource: item.columns,
                          gldBal: item.gldBal,
                          toBeGldPaid: item.toBeGldPaid,
                          formSource: item.form,
                          fromTypeRouter: item.fromType,
                          fromPath: "circulation/goldpay",
                          selectName: item.selectName,
                          selectProp: item.selectProp
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2919512c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2919512c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/circulation/goldpay.vue
// module id = 4igS
// module chunks = 1